<template>
  <v-form v-model="valid" ref="form">
    <v-dialog overlay-opacity="0.7" v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{$t('delete_address')}}</v-card-title>
        <v-card-text>{{$t('you_sure')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="error" @click="deleteComponent(detail)" :loading="loading">{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="pt-3 container">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row>
            <v-col md="12">
              <v-card-title>
                <span class="headline">{{$t('address')}}</span>
              </v-card-title>
              <v-card-text>
                <v-row v-for="(item,i) in formData" v-bind:key="i">
                  <v-col cols="12">
                    <v-row align="center">
                      <v-divider></v-divider>
                      <v-btn plain disabled>{{i == 0 ? $t('home') : $t('identity_card')}}</v-btn>
                      <v-divider></v-divider>
                    </v-row>
                  </v-col>
                  <v-col class="pt-0 pb-0">
                    <v-textarea :label="$t('address')" v-model="item.address" auto-grow rows="1" readonly></v-textarea>
                  </v-col>
                  <v-col cols="3" class="text-right" v-if="!item.dataReady">
                    <v-btn :class="resizeLang" color="primary" @click="add(i)">
                      <v-icon class="pr-1">mdi-plus</v-icon>{{$t('add_address')}}
                    </v-btn>
                  </v-col>
                  <v-col cols="2" class="text-right" v-if="item.dataReady">
                    <v-btn color="primary" @click="seeDetail(item)">
                      <v-icon small class="pr-1">mdi-pencil</v-icon>{{$t('edit')}}
                    </v-btn>
                  </v-col>
                  <v-col cols="12" class="pa-0 ma-0"></v-col>
                  <!-- <v-col cols="2" class="pt-0 pb-0">
                    <v-text-field label="RT" v-model="item.RT" readonly></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pt-0 pb-0">
                    <v-text-field label="RW" v-model="item.RW" readonly></v-text-field>
                  </v-col> 
                  <v-col cols="4" class="pt-0 pb-0">
                    <v-text-field label="Province" v-model="item.province" readonly></v-text-field>
                  </v-col>-->
                  <v-col cols="5" class="pt-0 pb-0">
                    <v-select
                      :label="$t('city')"
                      v-model="item.city"
                      :items="tempData[i]"
                      item-text="nama"
                      item-value="id"
                      readonly
                    ></v-select>
                  </v-col>
                  <!-- <v-col cols="4" class="pt-0 pb-0">
                    <v-text-field label="Subdistrict" v-model="item.subDistrict" readonly></v-text-field>
                  </v-col>-->
                  <!-- <v-col cols="4" class="pt-0 pb-0">
                    <v-text-field label="District" v-model="item.district" readonly></v-text-field>
                  </v-col>-->
                  <v-col cols="5" class="pt-0 pb-0">
                    <v-text-field :label="$t('postal_code')" v-model="item.postcode" readonly></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-row>
            <v-col md="6">
              <v-btn icon @click="tab = 0">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>{{$t('back')}}
            </v-col>
            <v-col md="6" class="text-right" v-if="isEdit">
              <v-btn icon @click="deleteItem(detail)" color="error">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
            <!-- <v-col md="12">
              <v-select
                label="Type"
                v-model="detail.type"
                :rules="rules5"
                :items="addressTypeList"
                item-text="name"
                item-value="value"
                required
                class="sae-required"
              ></v-select>
            </v-col>-->
            <v-col md="12">
              <v-textarea
                :label="$t('address')"
                v-model="detail.address"
                type="text"
                :rules="[...rules, validator.alfaNumberNotRequired]"
                auto-grow
                rows="1"
                required
                class="sae-required"
              ></v-textarea>
            </v-col>
            <v-col md="6">
              <v-text-field
                label="RT"
                v-model="detail.RT"
                type="text"
                :rules="[...rules, validator.alfaNumberNotRequired]"
                required
                class="sae-required"
              ></v-text-field>
            </v-col>
            <v-col md="6">
              <v-text-field
                label="RW"
                v-model="detail.RW"
                type="text"
                :rules="[...rules, validator.alfaNumberNotRequired]"
                required
                class="sae-required"
              ></v-text-field>
            </v-col>
            <v-col md="12">
              <v-select
                :label="$t('province')"
                v-model="detail.province"
                :items="provinceList"
                item-text="nama"
                item-value="id"
                :rules="rules2"
                required
                class="sae-required"
                @change="provinceChange($event)"
              ></v-select>
            </v-col>
            <v-col md="12">
              <v-select
                :label="$t('city')"
                v-model="detail.city"
                :items="cityList"
                item-text="nama"
                item-value="id"
                :rules="rules2"
                required
                class="sae-required"
                @change="cityChange($event)"
              ></v-select>
            </v-col>
            <v-col md="12">
              <v-select
                :label="$t('sub_district')"
                v-model="detail.subDistrict"
                :items="subDistrictList"
                item-text="nama"
                item-value="id"
                :rules="rules2"
                required
                class="sae-required"
                @change="subDistrictChange($event)"
              ></v-select>
            </v-col>
            <v-col md="12">
              <v-select
                :label="$t('district')"
                v-model="detail.district"
                :items="districtList"
                item-text="nama"
                item-value="id"
                :rules="rules2"
                required
                class="sae-required"
              ></v-select>
            </v-col>
            <v-col md="12">
              <v-text-field
                :label="$t('postal_code')"
                v-model="detail.postcode"
                :rules="[rules4a, validator.alfaNumberNotRequired]"
                type="text"
              ></v-text-field>
            </v-col>
            <v-col md="12" class="text-center">
              <v-btn plain class="ma-2 primary--text" @click="tab=0">{{$t('cancel')}}</v-btn>
              <v-btn
                color="primary"
                class="ma-2"
                :loading="loading"
                :disabled="!valid"
                @click="saveOrUpdate(detail)"
              >{{$t('save')}}</v-btn>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-form>
</template>

<script>
import moment from 'moment'

export default {
  props: ['userId', 'addressList'],
  name: "Address-List",
  data() {
    return {
      headers: [
        { text: "No", value: "no" },
        { text: this.$i18n.t('type'), value: "type" },
        { text: this.$i18n.t('city'), value: "city" },
        { text: this.$i18n.t('sub_district'), value: "subDistrict" },
        { text: "", value: "action" },
      ],

      deleteDialog: false,
      rules: [(value) => (value === 0 ? true : !!value || this.$i18n.t('required'))],
      rules2: [(value) => (value == 0 ? true : value ? value > 0 : !!value || this.$i18n.t('required'))],
      rules4a: v  => {
        if (v) { if (!v) return true; } 
        else { return true; }
        if (/^[0-9]+$/.test(v)) return true;
        return this.$i18n.t('number_required');
      },
      rules5: [(value) => (value ? value.length == 0 ? false || this.$i18n.t('required') : true : false || this.$i18n.t('required'))],
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      lang: this.$i18n.t('lang'),
      valid: false,
      formData: [
        { dataReady: false, address: '', },
        { dataReady: false, address: '', },
      ],
      userIdLogin: this.$store.getters.user.id,
      loading: false,
      detail: {},
      tab: 0,
      addressTypeList: [
        { id: 0, value: 'ID', name: this.$i18n.t('identity_card') },
        { id: 1, value: 'sae', name: this.$i18n.t('home') },
      ],
      isEdit: false,
      provinceList: [],
      cityList: [],
      subDistrictList: [],
      districtList: [],
      tempData: [
        [],
        []
      ]
    }
  },
  methods: {
    add(type) {
      this.isEdit = false
      this.detail = { userId: this.userId, type: type == 0 ? 'sae' : 'ID' }
      this.tab = 1
    },
    seeDetail(item) {
      this.isEdit = true
      this.detail = Object.assign({ userId: this.userId }, item)
      this.detail.type = item.type == 'Identity Card' ? 'ID' : 'sae'
      this.detail.province = parseInt(this.detail.province)
      this.detail.city = parseInt(this.detail.city)
      this.detail.subDistrict = parseInt(this.detail.subDistrict)
      this.detail.district = parseInt(this.detail.district)

      this.provinceChange(this.detail.province, true)
      this.cityChange(this.detail.city, true)
      this.subDistrictChange(this.detail.subDistrict, true)
      this.tab = 1
    },
    costumHeader(actionId, action) {
      return { headers: { actionId, action } }
    },
    formatTime(date) {
      return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY")
    },
    async provinceChange(id, skipClear = false) {
      this.cityList = await this.getCity(id)
      if (!skipClear) this.detail.city = null
    },
    async cityChange(id, skipClear = false) {
      this.subDistrictList = await this.getSubDistrict(id)
      if (!skipClear) this.detail.subDistrict = null
    },
    async subDistrictChange(id, skipClear = false) {
      this.districtList = await this.getDistrict(id)
      if (!skipClear) this.detail.district = null
    },
    async getProvince() {
      this.loading = true
      const result = await this.$store.dispatch('getProvince')
      this.loading = false
      return result
    },
    async getCity(id) {
      this.loading = true
      const result = await this.$store.dispatch('getCities', { id })
      this.loading = false
      return result
    },
    async getSubDistrict(id) {
      this.loading = true
      const result = await this.$store.dispatch('getSubdistrict', { id })
      this.loading = false
      return result
    },
    async getDistrict(id) {
      this.loading = true
      const result = await this.$store.dispatch('getDistrict', { id })
      this.loading = false
      return result
    },
    async saveOrUpdate(data) {
      if (this.isEdit) {
        this.editComponent(data)
      } else {
        this.saveComponent(data)
      }
    },
    async saveComponent(data) {
      const body = { ...data, addressType: data.type }
      // if (data.postcode != null) {
      //   if (data.postcode.length <= 0) {
      //     delete body.postcode
      //   }
      // }
      this.loading = true
      const result = await this.$store.dispatch('saveAddress', body)
      this.loading = false
      if (result) {
        this.$emit('reload', true)
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.tab = 0
        this.refreshData()
      }
    },
    async editComponent(data) {
      const body = { ...data, addressType: data.type }
      // if (data.postcode != null) {
      //   if (data.postcode.length <= 0) {
      //     delete body.postcode
      //   }
      // }
      this.loading = true
      const result = await this.$store.dispatch('editAddress', body)
      this.loading = false
      if (result) {
        this.$emit('reload', true)
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.tab = 0
        this.refreshData()
      }
    },
    deleteItem() {
      this.deleteDialog = true;
    },
    async deleteComponent(data) {
      const body = { ...data, addressType: data.type }
      this.loading = true
      const result = await this.$store.dispatch('deleteAddress', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_delete'))
        this.$emit('reload', true)
        this.tab = 0
        this.deleteDialog = false
      }
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', {type, msg})
    },
    refreshData() {
      this.tab = 0
      if (this.addressList) {
        this.formData = [{}, {}]
        this.addressList.map(async item => {
          switch (item.type) {
            case 'Home':
              this.formData[0] = Object.assign({ dataReady: true }, item)
              this.formData[0].city = parseInt(this.formData[0].city)
              this.tempData[0] = await this.getCity(parseInt(item.province))
              break;
            default:
              this.formData[1] = Object.assign({ dataReady: true }, item)
              this.formData[1].city = parseInt(this.formData[1].city)
              this.tempData[1] = await this.getCity(parseInt(item.province))
              break;
          }
        })
      } else {
        this.formData = [
          { dataReady: false, address: '', },
          { dataReady: false, address: '', },
        ]
        this.detail = {}
      }
    },
  },
   computed: {
    resizeLang() {
      if(this.lang === 'id'){
        return 'font-lang-12'
      }else{
        return ''
      }
    }
  },
  async created() {
    this.refreshData()
    this.provinceList = await this.getProvince()
  },
  watch: {
    addressList() {
      this.refreshData()
    },
    userId() {
      this.refreshData()
    },
    detail() {
      if (this.$refs.form && !this.isEdit) {
        this.$refs.form.reset();
      }
    }
  }
}
</script>
<style scoped>
.sae-grey {
  background: #7c8a963d;
  line-height: 35px;
  cursor: pointer;
}
</style>